import React from 'react';
import './ProgressCard.css';

export const ProgressCard = ({ title, children, icon, onClick, className = "" }) => {
    const content = (
        <div className={`progress-card ${className}`}>
            <h3 className="progress-card-title">{title}</h3>
            {icon && <div className="progress-card-icon">{icon}</div>}
            {children && <div className="progress-card-content">{children}</div>}
        </div>
    );

    if (onClick) {
        return (
            <button onClick={onClick} className="progress-card-btn">
                {content}
            </button>
        );
    }

    return content;
};
